import ultraPionnerImage from "./img/badge/ultra-pionner.webp";
import cloudCommanderImage from "./img/badge/cloud-commander.webp";
import trackMasterImage from "./img/badge/track-master.webp";
import tripplePowerImage from "./img/badge/triple-power.webp";
import powerSaverImage from "./img/badge/power-saver.webp";
import vapeDetecitveImage from "./img/badge/vape-detective.webp";
// import lastSeenImage from "./img/badge/last-seen.webp";
import dualConnectionImage from "./img/badge/dual-connection.webp";
import kalteKenner from "./img/badge/kalte-kenner.webp";
import tropenFreak from "./img/badge/tropen-freak.webp";
import flavourPro from "./img/badge/flavour-pro.webp";
import flavourBoss from "./img/badge/flavour-boss.webp";
import beerenFan from "./img/badge/beeren-fan.webp";

export const badgeCards = [
  {
    image: ultraPionnerImage,
    ident: "einzel",
    points: "20",
    completed: true,
    title: "Ultra Pionier",
    tooltip: "Verbinde dein Ultra-Gerät mit der MYVUSE App",
    tolltip_done: "Verbinde dein Ultra-Gerät mit der MYVUSE App",
  },
  {
    image: dualConnectionImage,
    ident: "dopple",
    points: "10",
    completed: false,
    title: "Doppel Verbinder",
    tooltip: "Füge ein zweites Gerät zu deinem MyVuse-Konto hinzu",
    tolltip_done: "Füge ein zweites Gerät zu deinem MyVuse-Konto hinzu",
  },
  {
    image: tripplePowerImage,
    ident: "dreifach",
    points: "5",
    completed: true,
    title: "Dreifach Power",
    tooltip: "Melde dich mit einem dritten Gerät in der MYVUSE App an",
    tolltip_done: "Melde dich mit einem dritten Gerät in der MYVUSE App an",
  },
  {
    image: vapeDetecitveImage,
    ident: "dampfdetektiv",
    points: "5",
    completed: true,
    title: "Dampfdetektiv",
    tooltip:
      "Aktiviere die Funktion „Find My Vape“, indem du deine Zustimmung gibst",
    tolltip_done:
      "Aktiviere die Funktion „Find My Vape“, indem du deine Zustimmung gibst",
  },
  {
    image: trackMasterImage,
    ident: "trackingmeister",
    points: "5",
    completed: true,
    title: "Tracking Meister",
    tooltip: "Überprüfe deine Statistiken im Usage Tracker",
    tolltip_done: "Überprüfe deine Statistiken im Usage Tracker",
  },

  {
    image: cloudCommanderImage,
    ident: "wolkkenkommandant",
    points: "5",
    completed: true,
    title: "Wolkenkommandant",
    tooltip: "Teste die Cloud Control-Funktion",
    tolltip_done: "Teste die Cloud Control-Funktion",
  },

  {
    image: powerSaverImage,
    ident: "energiesparer",
    points: "5",
    completed: true,
    title: "Energiesparer",
    tooltip: "Benutze die Energiesparfunktion",
    tolltip_done: "Benutze die Energiesparfunktion",
  },
  {
    image: kalteKenner,
    ident: "kalte_kenner",
    points: "10",
    completed: false,
    surprise: true,
    title: "Kalte Kenner",
    tooltip:
      "Diese besondere Leistung stellt eine Überraschung dar! Entdecke sie, indem du unsere Produkte, das Inspiration Club Programm und die MYVUSE App benutzt.",
    tolltip_done:
      "Kaufe mindestens 3 dieser Geschmacksrichtungen: Strawberry Ice, Blueberry Ice, Cherry Ice, Peppermint Ice",
  },
  {
    image: tropenFreak,
    ident: "tropen_freak",
    points: "10",
    completed: false,
    surprise: true,
    title: "Tropen Freak",
    tooltip:
      "Diese besondere Leistung stellt eine Überraschung dar! Entdecke sie, indem du unsere Produkte, das Inspiration Club Programm und die MYVUSE App benutzt.",
    tolltip_done:
      "Kaufe mindestens 2 dieser Geschmacksrichtungen: Mango Calamansi, Lemon & Lime, Berry Watermelon",
  },
  {
    image: flavourBoss,
    ident: "flavour_boss",
    points: "30",
    completed: false,
    surprise: true,
    tooltip:
      "Diese besondere Leistung stellt eine Überraschung dar! Entdecke sie, indem du unsere Produkte, das Inspiration Club Programm und die MYVUSE App benutzt.",
    title: "Flavour Boss",
    tolltip_done: "Kaufe alle 8 Geschmacksrichtungen",
  },
  {
    image: flavourPro,
    ident: "flavour_pro",
    points: "15",
    completed: false,
    surprise: true,
    tooltip:
      "Diese besondere Leistung stellt eine Überraschung dar! Entdecke sie, indem du unsere Produkte, das Inspiration Club Programm und die MYVUSE App benutzt.",
    title: "Flavour Pro",
    tolltip_done: "Kaufe mindestens 6 von 8 Geschmacksrichtungen",
  },
  {
    image: beerenFan,
    ident: "berren_fan",
    points: "10",
    completed: false,
    surprise: true,
    title: "Beeren Fan",
    tooltip:
      "Diese besondere Leistung stellt eine Überraschung dar! Entdecke sie, indem du unsere Produkte, das Inspiration Club Programm und die MYVUSE App benutzt.",
    tolltip_done:
      "Kaufe mindestens 2 dieser Geschmacksrichtungen: Strawberry Ice, Blueberry Ice, Berry Watermelon.",
  },

  // {
  //   image: lastSeenImage,
  //   points: "10",
  //   completed: true,
  //   title: "Last<br/> Seen",
  //   tooltip: "Melde dich mit einem dritten Gerät in der MyVuse-App an",
  // },
];
